import { MenuItem, Select, Typography, type SelectChangeEvent } from "@mui/material";
import type { FC } from "react";
import type { UsableAccountPersonField } from "../../../../server/supabase-segment-field-service";
import {
  filterFieldOperators,
  isRelativeDateCondition,
  mapDateOperator,
  mapToDateCondition,
  type DateOperator,
} from "../../../segment-operation/operators";
import type { Condition } from "../../types";

export const DateOpSelect: FC<{
  condition: Condition;
  fieldType: Extract<UsableAccountPersonField["field_type"], "DATE" | "MONTH_DAY">;
  handleFieldChange: (value: Partial<Condition>) => void;
  disabled?: boolean;
}> = ({ condition, fieldType, handleFieldChange, disabled }) => {
  const operator = mapDateOperator(condition);
  const showBlankValuesHelperText = operator === "NOT AFTER" || operator === "NOT BEFORE";

  return (
    <>
      <Select
        variant="outlined"
        size="small"
        label="Operator"
        onChange={(event: SelectChangeEvent) => {
          handleFieldChange({
            ...condition,
            ...mapToDateCondition(event.target.value as DateOperator, condition, fieldType),
          });
        }}
        labelId="operator-label"
        value={operator}
        disabled={disabled}
      >
        {filterFieldOperators[fieldType].operators.map((operatorInfo) => (
          <MenuItem key={operatorInfo.operator} value={operatorInfo.operator}>
            {operatorInfo.label()}
          </MenuItem>
        ))}
      </Select>
      {showBlankValuesHelperText ? (
        <Typography variant="caption" color="textSecondary" fontSize={10}>
          *includes blank values
        </Typography>
      ) : null}
      {isRelativeDateCondition(condition) ? (
        <Typography variant="caption" color="textSecondary" fontSize={10}>
          * relative to send date
        </Typography>
      ) : null}
    </>
  );
};
